module.exports = __webpack_public_path__ + "static/media/img2.919db697.jpg";